import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');

// ── Brand icons ───────────────────────────────────────────────────────────────
const BRAND = {
  facebook:  { bg:'#1877F2', d:'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
  instagram: { bg:'#E1306C', d:'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
  twitter:   { bg:'#000',    d:'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.713 5.88zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
  linkedin:  { bg:'#0A66C2', d:'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
  youtube:   { bg:'#FF0000', d:'M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' },
  tiktok:    { bg:'#000',    d:'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z' },
  whatsapp:  { bg:'#25D366', d:'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z' },
  telegram:  { bg:'#26A5E4', d:'M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z' },
  discord:   { bg:'#5865F2', d:'M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057.102 18.079.114 18.1.131 18.113a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z' },
  github:    { bg:'#181717', d:'M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12' },
  spotify:   { bg:'#1DB954', d:'M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z' },
  snapchat:  { bg:'#FFFC00', d:'M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.271 5.069l-.03.259c-.01.079-.02.153-.029.231.189.071.392.113.593.113.47 0 .926-.142 1.337-.41.163-.105.36-.149.547-.149.29 0 .578.095.791.277.578.485.576 1.297.08 1.862-.018.02-.099.101-.127.128-.257.252-.543.498-.782.66-.82.544-1.643.874-2.472 1.009-.013.021-.02.044-.028.065.033.088.073.172.117.25.439.771 1.281 1.647 2.527 1.741.244.019.428.205.428.449 0 .47-.574.941-1.818 1.319-.133.04-.268.083-.359.133a3.97 3.97 0 00-.147.065 2.12 2.12 0 01-.149.068c-.264.113-.557.238-.849.42-.617.384-1.121.868-1.534 1.446-.614.862-1.418 1.295-2.392 1.295h-.024c-.97-.002-1.815-.469-2.399-1.378-.393-.58-.897-1.063-1.515-1.45-.291-.18-.584-.305-.848-.418a2.12 2.12 0 01-.149-.068 3.97 3.97 0 00-.147-.065c-.091-.05-.226-.093-.359-.133-1.244-.378-1.818-.849-1.818-1.319 0-.244.184-.43.428-.449 1.246-.094 2.088-.97 2.527-1.741.044-.078.084-.162.117-.25-.008-.021-.015-.044-.028-.065-.829-.135-1.652-.465-2.472-1.009-.239-.162-.525-.408-.782-.66-.028-.027-.109-.108-.127-.128-.496-.565-.498-1.377.08-1.862.213-.182.501-.277.791-.277.187 0 .384.044.547.149.411.268.867.41 1.337.41.201 0 .404-.042.593-.113-.009-.078-.019-.152-.029-.231l-.03-.259c-.132-1.85-.258-3.876.271-5.069 1.583-3.545 4.94-3.821 5.93-3.821z' },
  threads:   { bg:'#000',    d:'M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.5 12.068l.003-.17C1.578 5.258 5.158 1.5 12.18 1.5h.043c6.775.072 10.383 3.827 10.383 10.618 0 .088-.004.172-.007.254l-.001.05c-.076 3.234-1.012 5.666-2.786 7.238-1.682 1.49-4.009 2.254-6.626 2.34zm-.006-2c2.29-.074 4.198-.679 5.508-1.834 1.33-1.175 2.06-3.113 2.123-5.795.002-.07.005-.143.006-.217.001-.1.002-.197.002-.296 0-5.763-3.013-8.68-8.336-8.737h-.04c-5.644.031-8.593 3.066-8.643 9.041l-.002.14c0 3.101.724 5.548 2.15 7.272 1.474 1.783 3.742 2.685 6.742 2.706h.49z' },
  wechat:    { bg:'#07C160', d:'M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-3.895-6.348-7.596-6.348z' },
  pinterest: { bg:'#E60023', d:'M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z' },
  reddit:    { bg:'#FF4500', d:'M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0z' },
  line:      { bg:'#00C300', d:'M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314z' },
  patreon:   { bg:'#FF424D', d:'M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21 0 3.96-3.22 7.18-7.18 7.18-3.97 0-7.21-3.22-7.21-7.18 0-3.97 3.24-7.21 7.21-7.21M0 21.6h3.76V2.4H0v19.2z' },
};
const EMOJI = { facebook:'FB',instagram:'IG',twitter:'X',linkedin:'LI',youtube:'YT',tiktok:'TT',snapchat:'SC',threads:'TH',wechat:'WC',whatsapp:'WA',discord:'DC',patreon:'PT',line:'LN',telegram:'TG',pinterest:'PI',reddit:'RD',github:'GH',spotify:'SP',google_scholar:'GS',researchgate:'RG' };

function BIcon({ platform, size = 18 }) {
  const b = BRAND[platform];
  const isLight = platform === 'snapchat';
  if (!b) return <span style={{ fontSize: size * .7, fontWeight: 700, color: '#fff' }}>{EMOJI[platform] || '→'}</span>;
  return (
    <span style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:size, height:size, borderRadius:4, flexShrink:0, background:b.bg, overflow:'hidden' }}>
      <svg viewBox="0 0 24 24" width={size*.62} height={size*.62} fill={isLight?'#000':'#fff'}><path d={b.d}/></svg>
    </span>
  );
}

// ── Payment gateways — logo path points to /public/images/ ───────────────────
const GATEWAYS = {
  esewa:      { label:'eSewa',      color:'#', icon:'💚', logo:'/images/esewa.png' },
  khalti:     { label:'Khalti',     color:'#', icon:'💜', logo:'/images/khalti.png' },
  connectips: { label:'ConnectIPS', color:'#', icon:'❤️', logo:'/images/connectips.png' },
  // imepay:     { label:'IME Pay',    color:'#E2231A', icon:'🧡', logo:'/images/imepay.png' },
  // prabhupay:  { label:'Prabhu Pay', color:'#0056A2', icon:'💙', logo:'/images/prabhupay.png' },
  // nabilpay:   { label:'Nabil Pay',  color:'#F7941D', icon:'🟠', logo:'/images/nabilpay.png' },
  // sirepay:    { label:'Sire Pay',   color:'#00A651', icon:'💚', logo:'/images/sirepay.png' },
  paypal:     { label:'PayPal',     color:'#', icon:'🔵', logo:'/images/paypal.png' },
  // wise:       { label:'Wise',       color:'#9FE870', icon:'🟢', logo:'/images/wise.png' },
  // binance:    { label:'Binance',    color:'#F3BA2F', icon:'🟡', logo:'/images/binance.png' },
  custom:     { label:'Pay',        color:'#64748b', icon:'💳', logo:null },
};

// ── GatewayIcon: renders PNG logo, falls back to emoji on error / missing ────
function GatewayIcon({ gw, size = 22 }) {
  const [failed, setFailed] = useState(false);
  if (!gw.logo || failed) {
    return <span style={{ fontSize: size * 0.75, lineHeight: 1 }}>{gw.icon}</span>;
  }
  return (
    <img
      src={gw.logo}
      alt={gw.label}
      width={size}
      height={size}
      onError={() => setFailed(true)}
      style={{ width: size, height: size, objectFit: 'contain', display: 'block', borderRadius: 3 }}
    />
  );
}

function qrPayload(wallet) {
  const key = wallet.gateway || 'custom';
  if (key === 'esewa')  return JSON.stringify({ eSewa_id: wallet.id, name: wallet.name || '' });
  if (key === 'khalti') return JSON.stringify({ khalti_id: wallet.id, name: wallet.name || '' });
  return wallet.link || wallet.id || '';
}
function qrImgUrl(text, size = 200) {
  return `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(text)}&size=${size}x${size}&margin=10`;
}

// ── i18n ──────────────────────────────────────────────────────────────────────
const I18N = {
  en:{ save:'Save', exchange:'Exchange', chat:'Chat', poweredBy:'Powered by', loading:'Loading…', notFound:'Profile not found', goBack:'← Go Back', phone:'Phone', workEmail:'Work Email', website:'Website', org:'At', org2:'Also At', social:'Social', links:'Links', custom:'Links', contact:'Contact', payments:'Pay Me' },
  ne:{ save:'सेभ', exchange:'आदान-प्रदान', chat:'च्याट', poweredBy:'द्वारा संचालित', loading:'लोड हुँदैछ…', notFound:'प्रोफाइल फेला परेन', goBack:'← फिर्ता', phone:'फोन', workEmail:'कार्य इमेल', website:'वेबसाइट', org:'मा', org2:'पनि', social:'सामाजिक', links:'लिंक', custom:'लिंकहरू', contact:'सम्पर्क', payments:'भुक्तानी' },
  hi:{ save:'सेव', exchange:'आदान-प्रदान', chat:'चैट', poweredBy:'द्वारा संचालित', loading:'लोड…', notFound:'प्रोफ़ाइल नहीं मिली', goBack:'← वापस', phone:'फोन', workEmail:'कार्य ईमेल', website:'वेबसाइट', org:'पर', org2:'भी', social:'सोशल', links:'लिंक', custom:'लिंक', contact:'संपर्क', payments:'भुगतान' },
  zh:{ save:'保存', exchange:'交换', chat:'聊天', poweredBy:'技术支持', loading:'加载中…', notFound:'未找到个人资料', goBack:'← 返回', phone:'电话', workEmail:'工作邮箱', website:'网站', org:'在', org2:'也在', social:'社交', links:'链接', custom:'链接', contact:'联系', payments:'付款' },
  ar:{ save:'حفظ', exchange:'تبادل', chat:'دردشة', poweredBy:'مدعوم من', loading:'جارٍ التحميل…', notFound:'لم يتم العثور', goBack:'← رجوع', phone:'هاتف', workEmail:'البريد', website:'موقع', org:'في', org2:'أيضاً', social:'اجتماعي', links:'روابط', custom:'روابط', contact:'اتصال', payments:'الدفع' },
  es:{ save:'Guardar', exchange:'Intercambiar', chat:'Chat', poweredBy:'Con tecnología de', loading:'Cargando…', notFound:'Perfil no encontrado', goBack:'← Volver', phone:'Teléfono', workEmail:'Email', website:'Sitio web', org:'En', org2:'También en', social:'Social', links:'Enlaces', custom:'Links', contact:'Contacto', payments:'Pago' },
  fr:{ save:'Sauver', exchange:'Échanger', chat:'Chat', poweredBy:'Propulsé par', loading:'Chargement…', notFound:'Profil introuvable', goBack:'← Retour', phone:'Téléphone', workEmail:'Email pro', website:'Site web', org:'Chez', org2:'Aussi à', social:'Réseaux', links:'Liens', custom:'Liens', contact:'Contact', payments:'Paiement' },
  de:{ save:'Speichern', exchange:'Austauschen', chat:'Chat', poweredBy:'Betrieben von', loading:'Laden…', notFound:'Profil nicht gefunden', goBack:'← Zurück', phone:'Telefon', workEmail:'E-Mail', website:'Website', org:'Bei', org2:'Auch bei', social:'Sozial', links:'Links', custom:'Links', contact:'Kontakt', payments:'Zahlung' },
  ja:{ save:'保存', exchange:'交換', chat:'チャット', poweredBy:'提供', loading:'読み込み中…', notFound:'見つかりません', goBack:'← 戻る', phone:'電話', workEmail:'メール', website:'サイト', org:'勤務先', org2:'でも', social:'ソーシャル', links:'リンク', custom:'リンク', contact:'連絡先', payments:'支払い' },
  ko:{ save:'저장', exchange:'교환', chat:'채팅', poweredBy:'제공', loading:'로드 중…', notFound:'찾을 수 없음', goBack:'← 돌아가기', phone:'전화', workEmail:'이메일', website:'웹사이트', org:'소속', org2:'또한', social:'소셜', links:'링크', custom:'링크', contact:'연락처', payments:'결제' },
};
const LANGS = [{ code:'en',label:'EN' },{ code:'ne',label:'NE' },{ code:'hi',label:'HI' },{ code:'zh',label:'ZH' },{ code:'ar',label:'AR' },{ code:'es',label:'ES' },{ code:'fr',label:'FR' },{ code:'de',label:'DE' },{ code:'ja',label:'JA' },{ code:'ko',label:'KO' }];
const getT = l => I18N[l] || I18N.en;

function rgb(hex) {
  const c = (hex || '#38bdf8').replace('#', '');
  const f = c.length === 3 ? c.split('').map(x => x+x).join('') : c;
  const n = parseInt(f, 16);
  return `${(n>>16)&255},${(n>>8)&255},${n&255}`;
}

// ── VCF ───────────────────────────────────────────────────────────────────────
async function fetchPhotoB64(url) {
  if (!url) return null;
  try {
    return await new Promise(resolve => {
      const img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = () => {
        const MAX = 200, sc = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        const w = Math.round(img.naturalWidth * sc), h = Math.round(img.naturalHeight * sc);
        const c = document.createElement('canvas'); c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        resolve(c.toDataURL('image/jpeg', 0.75).split(',')[1] || null);
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
  } catch { return null; }
}

async function downloadVCF(u) {
  const SV = { linkedin:1, twitter:1, instagram:1, facebook:1, github:1, youtube:1, tiktok:1, telegram:1, whatsapp:1, discord:1, pinterest:1, reddit:1, snapchat:1, wechat:1 };
  const ph = u.user_photo ? await fetchPhotoB64(u.user_photo) : null;
  const lines = [
    'BEGIN:VCARD', 'VERSION:3.0',
    `FN:${u.username||u.primaryFlapid||''}`,
    `N:${u.username||u.primaryFlapid||''};;;; `,
    u.organization      ? `ORG:${u.organization}` : '',
    u.jobtitle          ? `TITLE:${u.jobtitle}`   : '',
    u.description       ? `NOTE:${u.description}` : '',
    u.phone_number_1    ? `TEL;TYPE=CELL,PREF:${u.phone_number_1}` : '',
    u.phone_number_2    ? `TEL;TYPE=WORK:${u.phone_number_2}` : '',
    u.organizationemail ? `EMAIL;TYPE=WORK:${u.organizationemail}` : '',
    u.website_url       ? `URL;TYPE=WORK:${u.website_url}` : '',
    u.address           ? `ADR;TYPE=WORK:;;${u.address};;;;` : '',
    u.primaryFlapid     ? `URL;TYPE=PROFILE:${window.location.origin}/${u.primaryFlapid}` : '',
    ph ? `PHOTO;ENCODING=b;TYPE=JPEG:${ph}` : '',
    ...(u.socialLinks||[]).filter(s=>s.url).map(s =>
      SV[s.platform] ? `X-SOCIALPROFILE;TYPE=${s.platform}:${s.url}` : `URL;TYPE=${s.platform||'social'}:${s.url}`),
    ...(u.customLinks||[]).filter(c=>c.url).map(c=>`URL;TYPE=${(c.label||'link').replace(/\s+/g,'_')}:${c.url}`),
    'END:VCARD',
  ].filter(Boolean).join('\r\n');
  const a = Object.assign(document.createElement('a'), {
    href: URL.createObjectURL(new Blob([lines], { type:'text/vcard;charset=utf-8' })),
    download: `${u.username||u.primaryFlapid||'contact'}.vcf`,
  });
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
}

function track(ev, id, extra = {}) {
  if (!id?.trim()) return;
  const sid = sessionStorage.getItem('_fsid') || (() => {
    const i = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('_fsid', i); return i;
  })();
  axios.post(`${API_BASE}/analytics/track`, { eventType:ev, targetFlapid:id, sessionId:sid, referrer:document.referrer||undefined, ...extra }).catch(()=>{});
}



// ── CSS ───────────────────────────────────────────────────────────────────────
// NOTE: All 'Syne' references replaced with 'Plus Jakarta Sans'.
// The @import loads Plus Jakarta Sans instead of Syne.
const makeCSS = (acc, r, dark) => `
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent}
html{-webkit-text-size-adjust:100%;text-size-adjust:100%;scroll-behavior:smooth}
html,body,#root{height:100%;width:100%;overflow-x:hidden}
a{color:inherit;text-decoration:none}img{max-width:100%;display:block}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes up{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
@keyframes pg{0%,100%{opacity:.4;transform:translateX(-50%) scale(1)}50%{opacity:.7;transform:translateX(-50%) scale(1.07)}}
@keyframes fl{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
@keyframes barUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
.P{min-height:100dvh;width:100%;overflow-x:hidden;position:relative;font-family:'DM Sans',system-ui,sans-serif;background:${dark?'#08090f':'#f0f3ff'};color:${dark?'#eef2ff':'#111827'};-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
.P::before{content:'';position:fixed;inset:0;pointer-events:none;z-index:0;background:radial-gradient(ellipse 90% 35% at 50% 0%, rgba(${r},.18) 0%, transparent 60%)}
.TB{position:fixed;top:0;right:0;z-index:500;display:flex;align-items:center;gap:6px;padding:10px 12px;padding-right:max(12px,env(safe-area-inset-right,12px));padding-top:max(10px,env(safe-area-inset-top,10px))}
.LG{appearance:none;-webkit-appearance:none;padding:5px 9px;border-radius:20px;min-height:36px;min-width:48px;font-size:11px;font-weight:700;letter-spacing:.5px;cursor:pointer;outline:none;font-family:inherit;border:1px solid rgba(${r},.28);background:${dark?'rgba(8,9,15,.92)':'rgba(255,255,255,.93)'};color:${dark?'#94a3b8':'#475569'};backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);touch-action:manipulation}
.LG option{background:${dark?'#0d1525':'#fff'};color:${dark?'#e2e8f0':'#1e293b'}}
.TM{width:36px;height:36px;border-radius:50%;flex-shrink:0;border:1px solid rgba(${r},.28);background:${dark?'rgba(8,9,15,.92)':'rgba(255,255,255,.93)'};cursor:pointer;font-size:15px;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);touch-action:manipulation;-webkit-user-select:none;user-select:none}
.HR{position:relative;width:100%;height:clamp(140px,38vw,200px);overflow:visible;padding-bottom:clamp(36px,9vw,46px)}
.CV{position:absolute;inset:0;overflow:hidden}
.CV img{width:100%;height:100%;object-fit:cover;display:block;opacity:${dark?.50:.60}}
.CVD{width:100%;height:100%;background:radial-gradient(ellipse at 35% 65%, rgba(${r},.3) 0%, transparent 55%),radial-gradient(ellipse at 78% 22%, rgba(${r},.14) 0%, transparent 50%),linear-gradient(148deg,${dark?'#0c1628,#091c3a':'#d8e2ff,#bfcfff'})}
.CVG{position:absolute;inset:0;pointer-events:none;background:linear-gradient(to bottom,transparent 30%,${dark?'#08090f':'#f0f3ff'} 100%)}
.AG{position:absolute;bottom:clamp(-24px,-6vw,-16px);left:50%;width:clamp(80px,22vw,110px);height:clamp(80px,22vw,110px);border-radius:50%;pointer-events:none;z-index:1;background:radial-gradient(circle,rgba(${r},.5) 0%,transparent 70%);animation:pg 3s ease-in-out infinite}
.AV{position:absolute;bottom:clamp(-40px,-11vw,-46px);left:50%;transform:translateX(-50%);width:clamp(72px,19vw,88px);height:clamp(72px,19vw,88px);border-radius:50%;overflow:hidden;z-index:10;border:3px solid ${dark?'#08090f':'#f0f3ff'};box-shadow:0 0 0 2.5px ${acc},0 8px 32px rgba(${r},.48);background:${dark?'#111827':'#e0e8ff'};flex-shrink:0}
.AV img{width:100%;height:100%;object-fit:cover;display:block}
.AVI{width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-family:'Plus Jakarta Sans',sans-serif;font-size:clamp(24px,6.5vw,32px);font-weight:800;color:${acc};background:${dark?'linear-gradient(135deg,#0d1f3c,#152d55)':'linear-gradient(135deg,#dbeafe,#bfcfff)'}}
.BD{position:relative;z-index:1;width:100%;max-width:560px;margin:0 auto;padding-top:clamp(48px,12vw,60px);padding-left:max(12px,env(safe-area-inset-left,12px));padding-right:max(12px,env(safe-area-inset-right,12px));padding-bottom:32px}
.BD.hb{padding-bottom:max(100px,calc(84px + env(safe-area-inset-bottom,0px)))}
.u1{animation:up .38s cubic-bezier(.22,1,.36,1) both}
.u2{animation:up .38s cubic-bezier(.22,1,.36,1) .09s both}
.u3{animation:up .38s cubic-bezier(.22,1,.36,1) .18s both}
.NB{text-align:center;margin-bottom:16px;padding:0 8px}
.NM{font-family:'Plus Jakarta Sans',sans-serif;font-size:clamp(17px,5.2vw,26px);font-weight:800;letter-spacing:-.3px;line-height:1.2;word-break:break-word;overflow-wrap:break-word;hyphens:auto;margin-bottom:8px;color:${dark?'#eef2ff':'#111827'}}
.RL{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:4px;row-gap:3px;margin-bottom:4px;font-size:clamp(11px,3vw,13px);line-height:1.5}
.RT{color:${acc};font-weight:700}
.RS{color:${dark?'#334155':'#cbd5e1'}}
.RO{color:${dark?'#64748b':'#6b7280'};font-weight:500}
.AD{display:inline-flex;align-items:center;gap:4px;font-size:clamp(10px,2.5vw,12px);color:${dark?'#475569':'#9ca3af'};margin-top:5px}
.BI{font-size:clamp(11px,2.8vw,13px);line-height:1.7;margin-top:10px;color:${dark?'#64748b':'#6b7280'};word-break:break-word;hyphens:auto;padding:0 4px;max-width:420px;margin-left:auto;margin-right:auto}
.OB{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:12px;margin-bottom:8px;background:${dark?'rgba(255,255,255,.045)':'rgba(255,255,255,.9)'};border:1px solid rgba(${r},.14);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);transition:border-color .18s,transform .12s;min-width:0}
.OB.CL{cursor:pointer}.OB.CL:active{opacity:.82;transform:scale(.99)}.OB.CL:hover{border-color:rgba(${r},.3)}
.OL{width:38px;height:38px;min-width:38px;border-radius:8px;object-fit:contain;padding:2px;background:rgba(${r},.1);flex-shrink:0}
.OI{width:38px;height:38px;min-width:38px;border-radius:8px;flex-shrink:0;display:flex;align-items:center;justify-content:center;background:rgba(${r},.12);color:${acc};font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;font-weight:800}
.OBD{flex:1;min-width:0;overflow:hidden}
.OR{font-size:9px;text-transform:uppercase;letter-spacing:1px;font-weight:700;color:${dark?'#475569':'#9ca3af'};margin-bottom:2px}
.ON{font-size:12px;font-weight:700;color:${dark?'#e2e8f0':'#111827'};white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.OE{font-size:10px;color:${dark?'#475569':'#9ca3af'};margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.OG{font-size:14px;flex-shrink:0;color:${acc};margin-left:4px}
.SC{border-radius:14px;margin-bottom:8px;overflow:hidden;background:${dark?'rgba(255,255,255,.045)':'rgba(255,255,255,.92)'};border:1px solid rgba(${r},.1);box-shadow:0 1px 6px rgba(0,0,0,${dark?.14:.07})}
.SH{padding:10px 12px 8px;font-size:9px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:${acc};border-bottom:1px solid rgba(${r},.07);display:flex;align-items:center;gap:6px}
.CR{display:flex;align-items:center;gap:10px;padding:12px 12px;min-height:52px;border-bottom:1px solid rgba(${r},.05);text-decoration:none;transition:background .12s;-webkit-user-select:none;user-select:none;touch-action:manipulation;min-width:0;overflow:hidden}
.CR:last-child{border-bottom:none}.CR:active{background:rgba(${r},.07)}
.CI{width:34px;height:34px;min-width:34px;border-radius:8px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:16px;background:rgba(${r},.1);color:${acc}}
.CL2{flex:1;min-width:0;overflow:hidden}
.CLL{font-size:9px;text-transform:uppercase;letter-spacing:.7px;font-weight:700;color:${dark?'#475569':'#9ca3af'};margin-bottom:2px}
.CLV{font-size:12px;font-weight:600;color:${dark?'#e2e8f0':'#111827'};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}
.CA{font-size:16px;color:${dark?'#2d3748':'#cbd5e1'};flex-shrink:0;margin-left:6px}
.SG{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;padding:10px 10px}
@media(min-width:360px){.SG{grid-template-columns:repeat(4,1fr)}}
@media(min-width:400px){.SG{grid-template-columns:repeat(5,1fr)}}
@media(min-width:480px){.SG{grid-template-columns:repeat(auto-fill,minmax(68px,1fr))}}
.SI{display:flex;flex-direction:column;align-items:center;gap:4px;padding:8px 3px;border-radius:10px;text-decoration:none;background:${dark?'rgba(255,255,255,.055)':'rgba(0,0,0,.03)'};border:1px solid ${dark?'rgba(255,255,255,.07)':'rgba(0,0,0,.06)'};min-height:62px;transition:transform .13s,opacity .13s;touch-action:manipulation;cursor:pointer}
.SI:active{transform:scale(.9);opacity:.8}
.SIN{width:32px;height:32px;border-radius:8px;overflow:hidden;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.SNM{font-size:8px;font-weight:600;text-align:center;color:${dark?'#94a3b8':'#6b7280'};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 2px;text-transform:capitalize}
.PG{display:flex;flex-wrap:wrap;gap:6px;padding:10px 10px;overflow:hidden}
.PL{display:inline-flex;align-items:center;gap:4px;padding:7px 11px;border-radius:99px;min-height:34px;font-size:clamp(10px,2.5vw,12px);font-weight:600;text-decoration:none;background:${dark?'rgba(255,255,255,.055)':'rgba(0,0,0,.03)'};border:1px solid rgba(${r},.18);color:${dark?'#e2e8f0':'#111827'};transition:background .14s,transform .11s;touch-action:manipulation;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}
.PL:active{transform:scale(.95)}
.ML{display:flex;flex-direction:column;gap:6px}
.MR{display:flex;align-items:center;gap:11px;padding:11px 12px;border-radius:12px;min-height:54px;text-decoration:none;background:${dark?'rgba(255,255,255,.045)':'rgba(255,255,255,.92)'};border:1px solid ${dark?'rgba(255,255,255,.07)':'rgba(0,0,0,.06)'};transition:border-color .15s,transform .12s;box-shadow:0 1px 5px rgba(0,0,0,${dark?.1:.05});touch-action:manipulation;overflow:hidden;min-width:0}
.MR:active{transform:scale(.98);border-color:rgba(${r},.3)}
.MI{width:38px;height:38px;min-width:38px;border-radius:10px;flex-shrink:0;display:flex;align-items:center;justify-content:center;overflow:hidden}
.ML2{flex:1;font-size:13px;font-weight:600;color:${dark?'#e2e8f0':'#111827'};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}
.MA{font-size:16px;color:${dark?'#2d3748':'#cbd5e1'};flex-shrink:0;margin-left:4px}
.CRV{display:grid;grid-template-columns:repeat(2,1fr);gap:8px}
@media(min-width:360px){.CRV{grid-template-columns:repeat(3,1fr)}}
@media(min-width:440px){.CRV{grid-template-columns:repeat(4,1fr)}}
@media(min-width:520px){.CRV{grid-template-columns:repeat(auto-fill,minmax(90px,1fr))}}
.CRI{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:12px 4px;border-radius:12px;text-decoration:none;min-height:80px;position:relative;overflow:hidden;background:${dark?'rgba(255,255,255,.045)':'rgba(255,255,255,.92)'};border:1px solid ${dark?'rgba(255,255,255,.06)':'rgba(0,0,0,.06)'};transition:transform .12s,opacity .12s;touch-action:manipulation}
.CRI:active{transform:scale(.93);opacity:.85}
.CRIC{width:40px;height:40px;border-radius:10px;overflow:hidden;display:flex;align-items:center;justify-content:center}
.CRIL{font-size:9px;font-weight:700;text-align:center;color:${dark?'#94a3b8':'#6b7280'};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 4px;text-transform:capitalize}
.BCH{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:8px}
.BC{display:inline-flex;align-items:center;gap:6px;padding:10px 12px;border-radius:10px;min-height:44px;text-decoration:none;font-size:12px;font-weight:600;color:${dark?'#e2e8f0':'#111827'};flex:1 1 calc(50% - 3px);min-width:0;max-width:100%;background:${dark?'rgba(255,255,255,.045)':'rgba(255,255,255,.94)'};border:1.5px solid rgba(${r},.2);transition:background .15s,transform .1s;touch-action:manipulation;overflow:hidden}
.BC:active{background:rgba(${r},.09);transform:scale(.98)}
.BC span:last-child{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;flex:1}
.AB{position:fixed;bottom:0;left:0;right:0;z-index:200;display:flex;gap:6px;justify-content:center;align-items:stretch;padding:8px 10px;padding-bottom:max(10px,env(safe-area-inset-bottom,10px));background:${dark?'rgba(8,9,15,.97)':'rgba(255,255,255,.97)'};border-top:1px solid rgba(${r},.11);backdrop-filter:blur(20px) saturate(160%);-webkit-backdrop-filter:blur(20px) saturate(160%);min-height:calc(52px + env(safe-area-inset-bottom,0px));animation:barUp .3s cubic-bezier(.22,1,.36,1) both}
.AB-btn{flex:1;min-width:0;max-width:180px;min-height:44px;padding:8px 4px;border-radius:12px;border:none;cursor:pointer;font-weight:700;font-size:clamp(9px,2.4vw,12px);font-family:inherit;display:flex;align-items:center;justify-content:center;gap:4px;text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:opacity .18s,transform .1s;touch-action:manipulation;-webkit-user-select:none;user-select:none}
.AB-btn:active{transform:scale(.95);opacity:.83}.AB-btn:disabled{opacity:.52;cursor:not-allowed}
.AB-sv{color:#fff}.AB-gh{color:${acc};border:1.5px solid rgba(${r},.3);background:rgba(${r},.1)}.AB-ct{color:#22c55e;border:1.5px solid rgba(37,211,102,.26);background:rgba(37,211,102,.09)}
.AB-btn span:first-child{font-size:clamp(12px,3vw,14px)}
.BSP{display:inline-block;width:12px;height:12px;border:2px solid rgba(255,255,255,.28);border-top-color:#fff;border-radius:50%;animation:spin .6s linear infinite;flex-shrink:0}
.OV{position:fixed;inset:0;z-index:600;background:rgba(0,0,0,.8);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);display:flex;align-items:flex-end;justify-content:center;animation:fadeIn .2s ease}
@media(min-width:520px){.OV{align-items:center;padding:20px}}
.MD{width:100%;max-width:480px;max-height:85dvh;overflow-y:auto;border-radius:22px 22px 0 0;padding:20px 14px;padding-bottom:max(20px,calc(env(safe-area-inset-bottom,0px) + 16px));background:${dark?'#0e1828':'#fff'};border:1px solid ${dark?'rgba(255,255,255,.1)':'rgba(0,0,0,.08)'};box-shadow:0 -14px 48px rgba(0,0,0,.42);-webkit-overflow-scrolling:touch}
@media(min-width:520px){.MD{border-radius:18px}}
.MH{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:16px}
.MT{font-family:'Plus Jakarta Sans',sans-serif;font-size:16px;font-weight:800;color:${dark?'#e2e8f0':'#111827'}}
.MS{font-size:11px;color:${dark?'#475569':'#9ca3af'};margin-top:3px}
.MX{width:32px;height:32px;min-width:32px;border-radius:8px;flex-shrink:0;border:1px solid ${dark?'rgba(255,255,255,.1)':'rgba(0,0,0,.1)'};background:${dark?'rgba(255,255,255,.06)':'rgba(0,0,0,.04)'};color:${dark?'#64748b':'#6b7280'};display:flex;align-items:center;justify-content:center;cursor:pointer;touch-action:manipulation;font-size:13px}
.MF{margin-bottom:12px}
.MLB{display:block;font-size:9px;text-transform:uppercase;letter-spacing:1px;font-weight:800;color:${dark?'#475569':'#9ca3af'};margin-bottom:5px}
.MIP{width:100%;border-radius:10px;padding:11px 12px;min-height:46px;outline:none;font-family:inherit;background:${dark?'rgba(255,255,255,.06)':'rgba(0,0,0,.04)'};border:1px solid ${dark?'rgba(255,255,255,.1)':'rgba(0,0,0,.1)'};color:${dark?'#e2e8f0':'#111827'};transition:border-color .18s;font-size:16px}
.MIP:focus{border-color:${acc}}
.MER{color:#f87171;font-size:12px;margin-bottom:12px;padding:10px 12px;background:rgba(248,113,113,.08);border-radius:9px;border:1px solid rgba(248,113,113,.16)}
.MBS{display:flex;gap:8px;margin-top:12px}
.MC{flex:1;padding:11px;border-radius:10px;min-height:48px;border:1px solid ${dark?'rgba(255,255,255,.1)':'rgba(0,0,0,.1)'};background:${dark?'rgba(255,255,255,.05)':'rgba(0,0,0,.04)'};color:${dark?'#64748b':'#6b7280'};cursor:pointer;font-size:13px;font-family:inherit;touch-action:manipulation}
.MSB{flex:2;padding:11px;border-radius:10px;border:none;color:#fff;cursor:pointer;font-size:13px;font-weight:700;font-family:inherit;min-height:48px;touch-action:manipulation}.MSB:disabled{opacity:.54;cursor:not-allowed}
.MOK{text-align:center;padding:16px 0 8px}
.MOI{font-size:48px;margin-bottom:12px;animation:fl 2s ease-in-out infinite}
.MOT{font-family:'Plus Jakarta Sans',sans-serif;font-size:18px;font-weight:800;color:${dark?'#e2e8f0':'#111827'};margin-bottom:8px}
.MOS{font-size:12px;color:${dark?'#475569':'#9ca3af'};margin-bottom:20px;line-height:1.65}
.MOB{width:100%;padding:13px;border-radius:10px;border:none;color:#fff;cursor:pointer;font-size:14px;font-weight:700;font-family:inherit;min-height:48px;touch-action:manipulation}
.LS{min-height:100dvh;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#08090f;color:#e2e8f0;gap:14px;padding:28px;text-align:center;font-family:'DM Sans',system-ui,sans-serif}
.SPR{width:36px;height:36px;border-radius:50%;border:3px solid rgba(56,189,248,.1);border-top-color:#38bdf8;animation:spin .8s linear infinite}
.SH2{font-size:13px;color:#475569}
.LIC{font-size:48px;animation:fl 3s ease-in-out infinite}
.LIT{font-family:'Plus Jakarta Sans',sans-serif;font-size:18px;font-weight:800}
.LIM{font-size:12px;color:#475569;max-width:280px;line-height:1.65}
.LBK{padding:11px 26px;border-radius:10px;border:1px solid rgba(56,189,248,.22);background:rgba(56,189,248,.08);color:#38bdf8;cursor:pointer;font-size:13px;font-family:inherit;font-weight:600;min-height:46px;margin-top:6px;touch-action:manipulation}
.FT{text-align:center;margin-top:28px;font-size:10px;color:${dark?'#1e293b':'#cbd5e1'};padding-bottom:env(safe-area-inset-bottom,0px);letter-spacing:.4px}
.DV{height:1px;background:rgba(${r},.07);margin:0 12px}
.TAG-CARD{text-align:center;padding:24px 16px;background:${dark?'rgba(255,255,255,.05)':'rgba(255,255,255,.9)'};border-radius:20px;border:1px solid rgba(${r},.2);margin-top:20px}
.PLATE{background:#fff;color:#000;padding:8px 16px;border-radius:6px;font-family:'Plus Jakarta Sans',sans-serif;font-weight:800;font-size:22px;display:inline-block;margin:12px 0;border:3px solid #000;box-shadow:0 4px 0 #ddd;letter-spacing:1px}
.LOST-BANNER{background:#f87171;color:#fff;padding:10px;border-radius:12px;font-weight:700;font-size:13px;margin-bottom:16px;animation:fl 2s infinite ease-in-out}
.TAG-DESC{color:${dark?'#94a3b8':'#64748b'};font-size:14px;line-height:1.6;margin-bottom:20px}
.PAY-ROW{display:flex;align-items:center;gap:12px;padding:11px 12px;border:none;cursor:pointer;background:transparent;border-radius:10px;transition:background .14s;width:100%;touch-action:manipulation;text-align:left;font-family:inherit}
.PAY-ROW:active{background:rgba(${r},.06)}
.PAY-QR-WRAP{display:flex;flex-direction:column;align-items:center;gap:12px;padding:16px 12px 20px;background:${dark?'rgba(255,255,255,.03)':'rgba(0,0,0,.02)'};border-radius:0 0 10px 10px;border-top:1px solid rgba(${r},.06)}
.PAY-QR-IMG{padding:12px;background:#fff;border-radius:16px;box-shadow:0 6px 28px rgba(${r},.22)}
@media(min-width:480px){
  .BD{padding-left:20px;padding-right:20px}.NM{font-size:24px}
  .AB-btn{font-size:13px;padding:10px 10px;min-height:48px}
  .SG{gap:9px;padding:11px 12px}.SI{padding:10px 4px;min-height:68px}.SIN{width:36px;height:36px}.SNM{font-size:9px}
  .CR{padding:14px 14px;min-height:56px}.CI{width:38px;height:38px;font-size:18px}.CLV{font-size:13px}
  .PL{padding:8px 13px;min-height:38px;font-size:13px}
  .MR{padding:13px 14px;min-height:58px}.MI{width:42px;height:42px}.ML2{font-size:14px}
  .CRI{padding:14px 6px;min-height:90px}.CRIC{width:44px;height:44px}.CRIL{font-size:10px}
  .BC{padding:12px 14px;min-height:48px;font-size:13px;flex:1 1 140px}
  .OB{padding:12px 14px;gap:12px}.OL{width:42px;height:42px}.OI{width:42px;height:42px;font-size:17px}.ON{font-size:13px}.OE{font-size:11px}.OG{font-size:16px}
  .HR{height:clamp(160px,40vw,220px);padding-bottom:clamp(40px,10vw,50px)}
  .AV{width:clamp(80px,20vw,96px);height:clamp(80px,20vw,96px);bottom:clamp(-44px,-12vw,-50px)}.AVI{font-size:clamp(28px,7vw,34px)}
  .AG{width:clamp(90px,24vw,120px);height:clamp(90px,24vw,120px)}.BD{padding-top:clamp(56px,14vw,66px)}
}
@media(min-width:600px){.BD{padding-left:24px;padding-right:24px}.NM{font-size:26px}}
`

// ── Payment Wallets ────────────────────────────────────────────────────────────
// GatewayIcon is now used in THREE places:
//   1. The collapsed row badge (left icon)
//   2. The expanded gateway-name pill
//   3. (Inherited via gw.icon fallback when no logo)
function PaymentWallets({ wallets, r, dark, pid }) {
  const [expanded, setExpanded] = useState({});
  if (!wallets?.length) return null;

  return (
    <div className="SC">
      <div className="SH">💳 Pay Me</div>
      <div style={{ padding:'10px 12px', display:'flex', flexDirection:'column', gap:8 }}>
        {wallets.map((w, i) => {
          const gw   = GATEWAYS[w.gateway] || GATEWAYS.custom;
          const text = qrPayload(w);
          const open = !!expanded[i];
          return (
            <div key={i}>
              {/* ── Collapsed row ── */}
              <button
                className="PAY-ROW"
                onClick={() => {
                  setExpanded(p => ({ ...p, [i]: !p[i] }));
                  if (!open) track('link_click', pid, { metadata:{ linkType:'payment' } });
                }}
                style={{ background: open ? `rgba(${r},.06)` : 'transparent', borderRadius: open ? '10px 10px 0 0' : 10 }}
              >
                {/* SPOT 1: gateway icon badge — now uses GatewayIcon, not {gw.icon} */}
                <div style={{
                  width: 36, height: 36, minWidth: 36, borderRadius: 10,
                  background: gw.color,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  padding: 7, flexShrink: 0, overflow: 'hidden',
                }}>
                  <GatewayIcon gw={gw} size={22}/>
                </div>

                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:700, color: dark?'#e2e8f0':'#111827' }}>
                    {gw.label}{w.name ? ` — ${w.name}` : ''}
                  </div>
                  <div style={{ fontSize:11, color: dark?'#475569':'#9ca3af', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                    {open ? 'Tap to close' : (w.id || 'Tap to show QR')}
                  </div>
                </div>

                <div style={{
                  fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 99,
                  background: open ? `rgba(${r},.12)` : 'rgba(255,255,255,.06)',
                  color: open ? gw.color : (dark ? '#475569' : '#9ca3af'),
                  flexShrink: 0,
                }}>
                  {open ? '✕ Close' : '📱 QR'}
                </div>
              </button>

              {/* ── Expanded QR panel ── */}
              {open && (
                <div className="PAY-QR-WRAP">
                  <div className="PAY-QR-IMG">
                    <img
                      src={qrImgUrl(text, 180)}
                      alt={`${gw.label} QR`}
                      style={{ width:180, height:180, display:'block', borderRadius:8 }}
                      loading="lazy"
                    />
                  </div>

                  <div style={{ textAlign:'center' }}>
                    {/* SPOT 2: gateway name pill — now uses GatewayIcon, not {gw.icon} */}
                    <div style={{
                      display: 'inline-flex', alignItems: 'center', gap: 7,
                      padding: '6px 14px', borderRadius: 99,
                      background: gw.color + '18', border: `1px solid ${gw.color}44`,
                      marginBottom: 8,
                    }}>
                      <GatewayIcon gw={gw} size={18}/>
                      <span style={{ fontSize:12, fontWeight:700, color:gw.color }}>{gw.label}</span>
                    </div>
                    {w.id && (
                      <div style={{ fontSize:15, fontWeight:700, color: dark?'#e2e8f0':'#111827', marginTop:4, letterSpacing:.5 }}>
                        {w.id}
                      </div>
                    )}
                    {w.name && (
                      <div style={{ fontSize:12, color: dark?'#64748b':'#6b7280', marginTop:2 }}>
                        {w.name}
                      </div>
                    )}
                  </div>

                  {w.link && (
                    <a href={w.link} target="_blank" rel="noreferrer"
                      style={{ padding:'8px 18px', borderRadius:10, background:gw.color, color:'#fff', fontSize:12, fontWeight:700, textDecoration:'none' }}>
                      Open {gw.label} →
                    </a>
                  )}

                  <div style={{ fontSize:10, color: dark?'#334155':'#cbd5e1', textAlign:'center' }}>
                    Scan with {gw.label} app to pay directly
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Multi-org block ────────────────────────────────────────────────────────────
function MultiOrgBlocks({ user, t, navigate }) {
  const orgs = (user.organizations?.length)
    ? user.organizations.filter(o => o.name || o.logo)
    : [
        ...(user.organization||user.organization_logo ? [{ name:user.organization, jobtitle:user.jobtitle, logo:user.organization_logo, email:user.organizationemail, website:user.website_url, businessFlapid:user.businessFlapid, isPrimary:true }] : []),
        ...(user.organization2||user.organization2_logo ? [{ name:user.organization2, jobtitle:user.jobtitle2, logo:user.organization2_logo, email:null, website:user.organization2_url, businessFlapid:user.businessFlapid2, isPrimary:false }] : []),
      ];
  if (!orgs.length) return null;
  return (
    <>
      {orgs.map((org, i) => {
        if (!org.name && !org.logo) return null;
        const cl = !!(org.businessFlapid || org.website);
        const label = org.isPrimary ? (org.jobtitle || t.org) : (org.jobtitle || t.org2);
        return (
          <div key={i} className={`OB${cl ? ' CL' : ''}`}
            onClick={cl ? (org.businessFlapid ? () => navigate('/b/' + org.businessFlapid) : () => window.open(org.website, '_blank')) : undefined}>
            {org.logo
              ? <img className="OL" src={org.logo} alt={org.name}/>
              : <div className="OI">{(org.name || 'O')[0].toUpperCase()}</div>
            }
            <div className="OBD">
              {label && <div className="OR">{label}</div>}
              <div className="ON">{org.name}</div>
              {org.email && <div className="OE">{org.email}</div>}
            </div>
            {cl && <div className="OG">{org.businessFlapid ? '🏢' : '↗'}</div>}
          </div>
        );
      })}
    </>
  );
}

// ── Exchange Modal ─────────────────────────────────────────────────────────────
function ExModal({ acc, r, dark, onClose, flapId, t, css }) {
  const [form, setForm] = useState({ name:'', phone:'', email:'', organization:'', jobtitle:'' });
  const [sent, setSent] = useState(false);
  const [err,  setErr]  = useState('');
  const [busy, setBusy] = useState(false);
  const grad = `linear-gradient(135deg,rgba(${r},.9),${acc})`;

  useEffect(() => {
    const h = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const go = async () => {
    if (!form.name?.trim()) return setErr('Please enter your name.');
    if (!form.phone?.trim() && !form.email?.trim()) return setErr('Phone or email required.');
    setBusy(true); setErr('');
    try {
      const res = await axios.post(`${API_BASE}/contacts/exchange/${encodeURIComponent(flapId)}`, form);
      if (res.data?.success) setSent(true);
      else setErr(res.data?.error || 'Something went wrong.');
    } catch(e) { setErr(e.response?.data?.error || 'Could not send.'); }
    setBusy(false);
  };

  return (
    <div className="OV" onClick={e => e.target === e.currentTarget && onClose()}>
      <style>{css}</style>
      <div className="MD">
        {sent ? (
          <div className="MOK">
            <div className="MOI">✅</div>
            <div className="MOT">Contact Shared!</div>
            <div className="MOS">Your details have been sent to the profile owner.</div>
            <button className="MOB" style={{ background: grad }} onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            <div className="MH">
              <div>
                <div className="MT">🔄 {t.exchange}</div>
                <div className="MS">Share your contact details</div>
              </div>
              <button className="MX" onClick={onClose}>✕</button>
            </div>
            {[
              ['Your Name *', 'name',        'text',  'name'],
              ['Phone',       'phone',        'tel',   'tel'],
              ['Email',       'email',        'email', 'email'],
              ['Company',     'organization', 'text',  'organization'],
              ['Job Title',   'jobtitle',     'text',  'organization-title'],
            ].map(([l, k, tp, ac]) => (
              <div className="MF" key={k}>
                <label className="MLB">{l}</label>
                <input className="MIP" type={tp} value={form[k]} autoComplete={ac}
                  onChange={e => setForm(p => ({ ...p, [k]: e.target.value }))}
                  onKeyDown={e => e.key === 'Enter' && go()}/>
              </div>
            ))}
            {err && <div className="MER">⚠️ {err}</div>}
            <div className="MBS">
              <button className="MC" onClick={onClose}>Cancel</button>
              <button className="MSB" style={{ background: grad }} disabled={busy} onClick={go}>
                {busy ? '⏳ Sending…' : 'Send My Contact'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function UserInfo() {
  const { flapid: raw } = useParams();
  const navigate = useNavigate();
  const flapid = (raw || '').replace(/^:+/, '').trim();

  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const [showEx,  setShowEx]  = useState(false);
  const [dark,    setDark]    = useState(true);
  const [lang,    setLang]    = useState('en');
  const [saving,  setSaving]  = useState(false);

  useEffect(() => {
    if (!flapid) { setError('No FlapID provided'); setLoading(false); return; }
    axios.get(`${API_BASE}/userinfo/${encodeURIComponent(flapid)}`)
      .then(({ data }) => {
        if (data.isLost) { navigate(`/contactowner/${flapid}`, { replace: true }); return; }
        if (data.redirect) { window.location.href = data.redirect; return; }
        const p = data.user || data;
        const ctxUrl = p?.accessoryContext?.pinnedUrl?.trim();
        if (ctxUrl?.startsWith('http')) { window.location.href = ctxUrl; return; }
        const pid = p.primaryFlapid || p.username || flapid;
        const ctx = p.accessoryContext;
        if (ctx?.type === 'vehicle') {
  navigate(`/v/${flapid}`, { replace: true });
  return;
}
        if (ctx) track('accessory_tap', pid, { accessoryFlapid: flapid, metadata: { accessoryType: ctx.type } });
        else     track('profile_view', pid);
        setUser(p);
        if (p.language && I18N[p.language]) setLang(p.language);
        else {
          const n = (navigator.languages?.[0] || navigator.language || 'en').toLowerCase().split('-')[0];
          if (I18N[n]) setLang(n);
        }
        if (p.theme === 'light') setDark(false);
      })
      .catch(e => setError(e.response?.data?.error || 'Profile not found'))
      .finally(() => setLoading(false));
  }, [flapid, navigate]);

  const t = getT(lang);

  const save = useCallback(async () => {
    if (!user || saving) return;
    setSaving(true);
    await downloadVCF(user);
    track('contact_save', user.primaryFlapid || user.username || flapid);
    setSaving(false);
  }, [user, saving, flapid]);

  

  // ── Loading
  if (loading) return (
    <div className="LS">
      <style>{`*{box-sizing:border-box;margin:0;padding:0}html{-webkit-text-size-adjust:100%}@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600&display=swap');.LS{min-height:100dvh;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#07090f;color:#e2e8f0;gap:14px;padding:28px;text-align:center;font-family:'DM Sans',sans-serif}.SPR{width:36px;height:36px;border-radius:50%;border:3px solid rgba(56,189,248,.12);border-top-color:#38bdf8;animation:spin .8s linear infinite}@keyframes spin{to{transform:rotate(360deg)}}.SH2{font-size:13px;color:#475569}`}</style>
      <div className="SPR"/><span className="SH2">{t.loading}</span>
    </div>
  );

  // ── Error
  if (error) return (
    <div className="LS">
      <style>{`*{box-sizing:border-box;margin:0;padding:0}html{-webkit-text-size-adjust:100%}@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@700;800&family=DM+Sans:wght@400;600&display=swap');.LS{min-height:100dvh;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#07090f;color:#e2e8f0;gap:14px;padding:28px;text-align:center;font-family:'DM Sans',sans-serif}.LIC{font-size:48px}.LIT{font-family:'Plus Jakarta Sans',sans-serif;font-size:18px;font-weight:800}.LIM{font-size:12px;color:#475569;max-width:280px;line-height:1.6}.LBK{padding:11px 26px;border-radius:10px;border:1px solid rgba(56,189,248,.25);background:rgba(56,189,248,.08);color:#38bdf8;cursor:pointer;font-size:13px;font-family:inherit;font-weight:600;min-height:46px;margin-top:6px}@keyframes fl{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}.LIC{animation:fl 3s ease-in-out infinite}`}</style>
      <div className="LIC">🪪</div>
      <div className="LIT">{t.notFound}</div>
      <div className="LIM">{error}</div>
      <button className="LBK" onClick={() => navigate(-1)}>{t.goBack}</button>
    </div>
  );

  if (!user) return null;

  const acc  = user.user_colour || '#38bdf8';
  const r    = rgb(acc);
  const pid  = user.primaryFlapid || user.username || flapid;
  const lay  = user.layout || 'card';
  const cb   = user.contactButtons || {};
  const showSave = cb.showSaveContact !== false;
  const showExch = cb.showExchangeContact !== false;
  const showChat = cb.showChat !== false;
  const chatPlat = cb.chatPlatform || 'whatsapp';
  const css  = makeCSS(acc, r, dark);
  const grad = `linear-gradient(135deg,rgba(${r},.88),${acc})`;

  const getChatUrl = () => {
    if (!showChat) return null;
    if (chatPlat === 'custom') return cb.chatUrl?.trim() || null;
    if (chatPlat === 'telegram') {
      const tg = (user.socialLinks || []).find(s => s.platform === 'telegram');
      if (tg?.url) return tg.url;
      const ph = (user.phone_number_1 || '').replace(/\D/g, '');
      return ph ? `https://t.me/${ph}` : null;
    }
    const ph = (user.phone_number_1 || '').replace(/\D/g, '');
    return ph ? `https://wa.me/${ph}` : null;
  };

  const chatUrl    = getChatUrl();
  const showBar    = showSave || showExch || (showChat && chatUrl);
  const socs       = (user.socialLinks  || []).filter(s => s.url);
  const custs      = (user.customLinks  || []).filter(c => c.url);
  const payWallets = (user.paymentWallets || []).filter(w => (w.id || w.link) && w.showQR !== false);

  const allLinks = [
    ...(user.phone_number_1    ? [{ href:`tel:${user.phone_number_1}`,       icon:'📱', label:user.phone_number_1 }] : []),
    ...(user.organizationemail ? [{ href:`mailto:${user.organizationemail}`, icon:'✉️', label:user.organizationemail }] : []),
    ...(user.website_url       ? [{ href:user.website_url,                   icon:'🌐', label:t.website }] : []),
    ...socs.map(s  => ({ href:s.url, platform:s.platform, label:s.label || s.platform })),
    ...custs.map(c => ({ href:c.url, icon:'🔗', label:c.label || c.url })),
  ];

  // ── Tag view ────────────────────────────────────────────────────────────────
  if (user.tagType) {
    return (
      <div className="P">
        <style>{css}</style>
        <div className="BD" style={{ paddingTop: 40 }}>
          <div className="NB u1">
            <div className="AV" style={{ position:'static', margin:'0 auto 20px', transform:'none' }}>
              {user.owner?.photo
                ? <img src={user.owner.photo} alt=""/>
                : <div className="AVI">{user.tagType[0].toUpperCase()}</div>
              }
            </div>
            <h1 className="NM">{user.tag?.name || 'Flap Asset Tag'}</h1>
            {user.tag?.lostMode && (
              <div className="LOST-BANNER">⚠️ REPORTED LOST: {user.tag.lostMessage}</div>
            )}
          </div>
          <div className="TAG-CARD u2">
            {user.tagType === 'vehicle' && (<>
              <span style={{ fontSize:40 }}>🚗</span>
              <div className="PLATE">{user.tag.vehicle?.plateNumber}</div>
              <p className="TAG-DESC">Owner: <strong>{user.owner?.name}</strong><br/>If this vehicle is causing an issue or in an emergency, use the buttons below.</p>
            </>)}
            {user.tagType === 'bag' && (<>
              <span style={{ fontSize:40 }}>🎒</span>
              <h2 className="NM" style={{ marginTop:10 }}>Found this item?</h2>
              <p className="TAG-DESC">Description: <strong>{user.tag.bag?.description}</strong><br/>Please help return this to the owner using the contact info below.</p>
            </>)}
            {user.tagType === 'home' && (<>
              <span style={{ fontSize:40 }}>🏠</span>
              <h2 className="NM" style={{ marginTop:10 }}>{user.tag.home?.gateLabel}</h2>
              <p className="TAG-DESC">{user.tag.home?.instructions}</p>
            </>)}
          </div>
          {showBar && (
            <div className="AB">
              {showChat && chatUrl && (
                <a href={chatUrl} className="AB-btn AB-sv" style={{ background: grad }}>
                  <span>📱</span><span>WhatsApp Owner</span>
                </a>
              )}
              {user.owner?.phone && (
                <a href={`tel:${user.owner.phone}`} className="AB-btn AB-gh">
                  <span>📞</span><span>Call Owner</span>
                </a>
              )}
            </div>
          )}
          <div className="FT" style={{ marginTop:40 }}>
            {t.poweredBy} <span style={{ color:acc, fontWeight:700 }}>Flap</span>
          </div>
        </div>
      </div>
    );
  }

  // ── Normal profile ──────────────────────────────────────────────────────────
  return (
    <div className="P">
      <style>{css}</style>

      {showEx && (
        <ExModal acc={acc} r={r} dark={dark} onClose={() => setShowEx(false)} flapId={pid} t={t} css={css}/>
      )}

      <div className="TB">
        <select className="LG" value={lang} onChange={e => setLang(e.target.value)} aria-label="Select language">
          {LANGS.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
        </select>
        <button className="TM" onClick={() => setDark(d => !d)} aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}>
          {dark ? '☀️' : '🌙'}
        </button>
      </div>

      <div className="HR" role="banner">
        <div className="CV">
          {user.user_cover_photo ? <img src={user.user_cover_photo} alt="Cover"/> : <div className="CVD"/>}
        </div>
        <div className="CVG"/>
        <div className="AG" aria-hidden="true"/>
        <div className="AV">
          {user.user_photo
            ? <img src={user.user_photo} alt={`${user.username || 'Profile'} photo`}/>
            : <div className="AVI" aria-hidden="true">
                {(user.username || user.primaryFlapid || flapid || '?')[0].toUpperCase()}
              </div>
          }
        </div>
      </div>

      <div className={`BD${showBar ? ' hb' : ''}`} role="main">

        <div className="NB u1">
          <h1 className="NM">{user.username || user.primaryFlapid || flapid}</h1>
          {(user.jobtitle || user.organization) && (
            <div className="RL">
              {user.jobtitle    && <span className="RT">{user.jobtitle}</span>}
              {user.jobtitle && user.organization && <span className="RS">·</span>}
              {user.organization && <span className="RO">{user.organization}</span>}
            </div>
          )}
          {user.jobtitle2 && user.organization2 && (
            <div className="RL" style={{ fontSize:'clamp(10px,2.6vw,12px)', opacity:.8 }}>
              <span className="RO">{user.jobtitle2}</span>
              <span className="RS">·</span>
              <span className="RO">{user.organization2}</span>
            </div>
          )}
          {user.address    && <div className="AD">📍 {user.address}</div>}
          {user.description && <p className="BI">{user.description}</p>}
        </div>

        <div className="u2">
          <MultiOrgBlocks user={user} t={t} navigate={navigate}/>
        </div>

        <div className="u3">

          {/* CARD layout */}
          {!['minimal','business','creative'].includes(lay) && (<>
            {(user.phone_number_1||user.phone_number_2||user.phone_number_3||user.organizationemail) && (
              <div className="SC">
                <div className="SH">📞 {t.contact}</div>
                {user.phone_number_1 && <a href={`tel:${user.phone_number_1}`} className="CR" onClick={()=>track('link_click',pid,{metadata:{linkType:'phone'}})}><div className="CI">📱</div><div className="CL2"><div className="CLL">{t.phone}</div><span className="CLV">{user.phone_number_1}</span></div><div className="CA">›</div></a>}
                {user.phone_number_2 && <a href={`tel:${user.phone_number_2}`} className="CR"><div className="CI">📞</div><div className="CL2"><div className="CLL">{t.phone} 2</div><span className="CLV">{user.phone_number_2}</span></div><div className="CA">›</div></a>}
                {user.phone_number_3 && <a href={`tel:${user.phone_number_3}`} className="CR"><div className="CI">☎️</div><div className="CL2"><div className="CLL">{t.phone} 3</div><span className="CLV">{user.phone_number_3}</span></div><div className="CA">›</div></a>}
                {user.organizationemail && <a href={`mailto:${user.organizationemail}`} className="CR" onClick={()=>track('link_click',pid,{metadata:{linkType:'email'}})}><div className="CI">✉️</div><div className="CL2"><div className="CLL">{t.workEmail}</div><span className="CLV">{user.organizationemail}</span></div><div className="CA">›</div></a>}
              </div>
            )}
            {(user.website_url||user.googlereview_url||user.tripadvisor_url||user.customreview_url) && (
              <div className="SC">
                <div className="SH">🔗 {t.links}</div>
                <div className="PG">
                  {user.website_url && <a href={user.website_url} target="_blank" rel="noreferrer" className="PL" onClick={()=>track('link_click',pid,{metadata:{linkType:'special'}})}>🌐 {t.website}</a>}
                  {user.googlereview_url && <a href={user.googlereview_url} target="_blank" rel="noreferrer" className="PL" onClick={()=>track('link_click',pid,{metadata:{linkType:'review'}})}>⭐ Google</a>}
                  {user.tripadvisor_url && <a href={user.tripadvisor_url} target="_blank" rel="noreferrer" className="PL" onClick={()=>track('link_click',pid,{metadata:{linkType:'review'}})}>✈️ TripAdvisor</a>}
                  {user.customreview_url && <a href={user.customreview_url} target="_blank" rel="noreferrer" className="PL" onClick={()=>track('link_click',pid,{metadata:{linkType:'review'}})}>🔗 Review</a>}
                </div>
              </div>
            )}
            {socs.length > 0 && (
              <div className="SC">
                <div className="SH">🌐 {t.social}</div>
                <div className="SG">
                  {socs.map((sl,i) => (
                    <a key={i} href={sl.url} target="_blank" rel="noreferrer" className="SI" onClick={()=>track('link_click',pid,{metadata:{linkPlatform:sl.platform,linkType:'social'}})}>
                      <div className="SIN" style={{ background: BRAND[sl.platform]?.bg || `rgba(${r},.15)` }}><BIcon platform={sl.platform} size={18}/></div>
                      <span className="SNM">{sl.label || sl.platform}</span>
                    </a>
                  ))}
                </div>
              </div>
            )}
            <PaymentWallets wallets={payWallets} r={r} dark={dark} pid={pid}/>
            {custs.length > 0 && (
              <div className="SC">
                <div className="SH">🧩 {t.custom}</div>
                <div className="PG">
                  {custs.map((cl,i) => <a key={i} href={cl.url} target="_blank" rel="noreferrer" className="PL" onClick={()=>track('link_click',pid,{metadata:{linkType:'custom'}})}>🔗 {cl.label||cl.url}</a>)}
                </div>
              </div>
            )}
          </>)}

          {/* MINIMAL layout */}
          {lay === 'minimal' && (<>
            <div className="ML">
              {allLinks.map((lk,i) => {
                const b = BRAND[lk.platform];
                return (
                  <a key={i} href={lk.href} target={lk.href?.startsWith('http')?'_blank':undefined} rel="noreferrer" className="MR"
                    onClick={lk.platform?()=>track('link_click',pid,{metadata:{linkPlatform:lk.platform,linkType:'social'}}):undefined}>
                    <div className="MI" style={{ background: b ? b.bg : `rgba(${r},.15)` }}>
                      {lk.platform ? <BIcon platform={lk.platform} size={20}/> : <span style={{fontSize:18}}>{lk.icon}</span>}
                    </div>
                    <div className="ML2">{lk.label}</div>
                    <div className="MA">→</div>
                  </a>
                );
              })}
            </div>
            <PaymentWallets wallets={payWallets} r={r} dark={dark} pid={pid}/>
          </>)}

          {/* CREATIVE layout */}
          {lay === 'creative' && (<>
            <div className="CRV">
              {allLinks.map((lk,i) => {
                const b = BRAND[lk.platform];
                return (
                  <a key={i} href={lk.href} target={lk.href?.startsWith('http')?'_blank':undefined} rel="noreferrer" className="CRI"
                    onClick={lk.platform?()=>track('link_click',pid,{metadata:{linkPlatform:lk.platform,linkType:'social'}}):undefined}>
                    <div className="CRIC" style={{ background: b ? b.bg : `rgba(${r},.14)` }}>
                      {lk.platform ? <BIcon platform={lk.platform} size={24}/> : <span style={{fontSize:21}}>{lk.icon}</span>}
                    </div>
                    <div className="CRIL">{lk.label}</div>
                  </a>
                );
              })}
            </div>
            <PaymentWallets wallets={payWallets} r={r} dark={dark} pid={pid}/>
          </>)}

          {/* BUSINESS layout */}
          {lay === 'business' && (<>
            {(user.phone_number_1||user.organizationemail||user.website_url) && (
              <div className="BCH">
                {user.phone_number_1 && <a href={`tel:${user.phone_number_1}`} className="BC" onClick={()=>track('link_click',pid,{metadata:{linkType:'phone'}})}><span style={{flexShrink:0}}>📱</span><span>{user.phone_number_1}</span></a>}
                {user.organizationemail && <a href={`mailto:${user.organizationemail}`} className="BC" onClick={()=>track('link_click',pid,{metadata:{linkType:'email'}})}><span style={{flexShrink:0}}>✉️</span><span>{user.organizationemail}</span></a>}
                {user.website_url && <a href={user.website_url} target="_blank" rel="noreferrer" className="BC"><span style={{flexShrink:0}}>🌐</span><span>{t.website}</span></a>}
              </div>
            )}
            {socs.length > 0 && (
              <div className="SC">
                <div className="SH">🌐 {t.social}</div>
                <div className="SG">
                  {socs.map((sl,i) => (
                    <a key={i} href={sl.url} target="_blank" rel="noreferrer" className="SI" onClick={()=>track('link_click',pid,{metadata:{linkPlatform:sl.platform,linkType:'social'}})}>
                      <div className="SIN" style={{ background: BRAND[sl.platform]?.bg || `rgba(${r},.15)` }}><BIcon platform={sl.platform} size={18}/></div>
                      <span className="SNM">{sl.label||sl.platform}</span>
                    </a>
                  ))}
                </div>
              </div>
            )}
            <PaymentWallets wallets={payWallets} r={r} dark={dark} pid={pid}/>
            {custs.length > 0 && (
              <div className="SC">
                <div className="SH">🧩 {t.custom}</div>
                <div className="PG">
                  {custs.map((cl,i) => <a key={i} href={cl.url} target="_blank" rel="noreferrer" className="PL" onClick={()=>track('link_click',pid,{metadata:{linkType:'custom'}})}>🔗 {cl.label||cl.url}</a>)}
                </div>
              </div>
            )}
          </>)}

        </div>

        <div className="FT">
          {t.poweredBy} <span style={{ color:acc, fontWeight:700 }}>Flap</span>
        </div>
      </div>

      {showBar && (
        <div className="AB" role="toolbar" aria-label="Profile actions">
          {showSave && (
            <button className="AB-btn AB-sv" disabled={saving}
              style={{ background: saving ? `rgba(${r},.5)` : grad }}
              onClick={save} aria-label="Save contact">
              {saving ? <><span className="BSP"/><span>Saving…</span></> : <><span>📇</span><span>{t.save}</span></>}
            </button>
          )}
          {showExch && (
            <button className="AB-btn AB-gh"
              onClick={() => { setShowEx(true); track('contact_exchange', pid); }}
              aria-label="Exchange contact">
              <span>🔄</span><span>{t.exchange}</span>
            </button>
          )}
          {showChat && chatUrl && (
            <a href={chatUrl} target="_blank" rel="noreferrer" className="AB-btn AB-ct"
              onClick={() => track('chat_click', pid, { metadata: { chatPlatform: chatPlat } })}
              aria-label={`Chat on ${chatPlat}`}>
              <span>💬</span>
              <span>{chatPlat === 'telegram' ? 'Telegram' : chatPlat === 'custom' ? t.chat : 'WhatsApp'}</span>
            </a>
          )}
        </div>
      )}
    </div>
  );
}